import React, { useEffect } from "react";
import { fetchAssets } from "src/actions/community/assetsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import ListVertical from "src/componets/ListVertical";
import { AssetInterface, selectSilentIds, selectSilentCount } from "src/store/community/assetsSlice";
import { EntityId } from "@reduxjs/toolkit";
import OptionalLink from "src/componets/OptionalLink";
import communityUrls from "src/configs/community/communityUrls";
import Loading from "src/componets/Loading";

interface propsInterface {
  app_id: number | undefined;
  target: string;
  loading?: boolean;
}

const _PreviewList = ({ app_id, target, loading } : propsInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => app_id ? selectSilentIds(state, app_id) : []);
  const count = useAppSelector(state => app_id ? selectSilentCount(state, app_id) : 0);
  const assets = useAppSelector(state => state.community.assets.entities);

  const renderAsset = (id: EntityId) => {
    const asset: AssetInterface | undefined = assets ? assets[id] : undefined;

    if (!asset) {
      return null;
    }

    return (
      <ListVertical.Item
        key={asset.id}
        image={asset.thumbnail_url}
      >
        {asset.title}
      </ListVertical.Item>
    )
  }

  useEffect(() => {
    const params = { app_id, limit: 10 };
    if (!app_id || !target || loading) {
      return;
    }

    dispatch(fetchAssets({ params, silentId: app_id }));
  }, [app_id, target, loading, dispatch]);

  return (
    <>
      <h6 className="v-content-label o-sm">{target.toUpperCase()} { count }</h6>
      <Loading loading={loading} />

      <ListVertical>
        { ids && assets && ids.map(renderAsset) }
      </ListVertical>

      {
        app_id &&
          <OptionalLink link={communityUrls.app(app_id).assetsPath()}>
            View All
          </OptionalLink>
      }
    </>
  );
}

export default _PreviewList;
